import { withNamespaces } from 'react-i18next';
import {
    Card,
    CardBody,
    CardTitle,
} from 'reactstrap';

import RiskMatrix from 'src/modules/3rd-party-management/components/RisksAndTasks/risks/matrix';

import usePackagingRiskMatrix from './hooks/usePackagingRiskMatrix';

const PackagingRiskMatrix = ({
    t,
}) => {
    const {
        data,
        isLoading,
        isFetching,
        isError,
    } = usePackagingRiskMatrix({ t });

    if (isError) {
        return null;
    }

    return (
        <Card className="mb-4">
            <CardBody>
                <CardTitle tag="h6" className="mb-4">
                    {t('Packaging Risk Matrix')}
                </CardTitle>

                <RiskMatrix
                    matrix={data?.matrix}
                    consequences={data?.consequences}
                    currency={data?.currency}
                    likelihoods={data?.likelihoods}
                    risks={null}
                    ratings={data?.ratings}
                    isLoading={isLoading || isFetching}
                />
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(PackagingRiskMatrix);
